module.exports = __webpack_public_path__ + "img/full_logo_color.1a867f1f.png";